/**
 * ModuleTerminalPaymentExperienceSpecs
 * @param {Object} data - content data
 * @return {Object} - normalized data
 *
 */
export default (data: any) => {
  return data
}
